import { c as _c } from "react-compiler-runtime";
import { useContext } from 'react';
import CollaborationSidebarPropsContext from '../contexts/CollaborationSidebarPropsContext';
import useGetPropsFromFAS from '../features/fas/hooks/useGetPropsFromFAS';
export default function useCollaborationSidebarProps() {
  "use memo";

  const $ = _c(10);
  const props = useContext(CollaborationSidebarPropsContext);
  const t0 = (props === null || props === void 0 ? void 0 : props.appName) || "";
  const t1 = props === null || props === void 0 ? void 0 : props.enabledFeatures;
  let t2;
  if ($[0] !== t0 || $[1] !== t1) {
    t2 = {
      appName: t0,
      enabledFeatures: t1
    };
    $[0] = t0;
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const {
    fasProps,
    loading: isLoadingFAS
  } = useGetPropsFromFAS(t2);
  if (!props) {
    throw new Error("CollaborationSidebarPropsContext not provided");
  }
  if (fasProps) {
    let t3;
    if ($[3] !== fasProps || $[4] !== isLoadingFAS || $[5] !== props) {
      t3 = Object.assign({}, props, fasProps, {
        isLoadingFAS
      });
      $[3] = fasProps;
      $[4] = isLoadingFAS;
      $[5] = props;
      $[6] = t3;
    } else {
      t3 = $[6];
    }
    return t3;
  }
  let t3;
  if ($[7] !== isLoadingFAS || $[8] !== props) {
    t3 = Object.assign({}, props, {
      isLoadingFAS
    });
    $[7] = isLoadingFAS;
    $[8] = props;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return t3;
}